import { combine } from 'react-hooks-combine'

import FooterComponent from './component'

export default combine({
  transformProps: ({ className }) => ({
    className,
    currentYear: new Date().getFullYear(),
  }),
})(FooterComponent)
